module.exports = "\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/collateral-deposit/edit-collateral-deposit/edit-collateral-deposit.component.css
// module id = ./src/app/collateral-deposit/edit-collateral-deposit/edit-collateral-deposit.component.css
// module chunks = main